<script setup lang="ts">
import Kraken from '@/components/library/illustrations/kraken.vue';
</script>

<template>
  <base-panel class="panel">
    <kraken />
    <h1><span class="font-bold">404</span> Media Resource does not exist</h1>
    <p>
      Sorry, you accessed an asset that does not exist or spelled incorrect!
    </p>

    <router-link class="link" to="/">Go to Channels</router-link>
  </base-panel>
</template>

<style scoped lang="postcss">
.panel {
  @apply p-4 flex flex-col items-center shadow-sm bg-white gap-8 max-w-3xl mx-auto;

  h1 {
    @apply text-4xl;
  }

  .link {
    @apply hover:underline transition-all;
  }
}
</style>
